// pdfjs-dist 5.x appelle Promise.try, absent de la ZoneAwarePromise de zone.js 0.14.
// Chargé via l'array `polyfills` de angular.json, juste après "zone.js", donc
// patche bien le Promise global (ZoneAwarePromise) avant tout usage applicatif.
if (typeof (Promise as any).try !== "function") {
  (Promise as any).try = function (fn: (...a: any[]) => any, ...args: any[]) {
    return new Promise((resolve) => resolve(fn(...args)));
  };
}
